export default "__VITE_ASSET__M_G3b4lA__"